import { Injectable } from '@angular/core';
import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  UrlTree,
} from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class MasterMultiBuyerRedirectGuard implements CanActivate {
  constructor(readonly auth: AuthService, readonly router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    const userRole = this.auth.user?.buyerAcssLvls;
    const url = route.routeConfig?.path;

    if (userRole !== 'masterMultiBuyer') {
      return true;
    }

    switch (url) {
      case ':id/edit':
      case ':id/edit/suppliers':
      case 'launch-survey/:id':
        return this.router.parseUrl('/access-denied');
      case 'create-surveys':
        return this.router.parseUrl('/create-templates');
      case 'create-templates':
        return true;
      default:
        return true;
    }
  }
}
